import AcceptingOrdersTable from '../components/accepting_orders/accepting_orders_table.vue'


export default {
  components: {
    AcceptingOrdersTable
  },
  data: () => ({
    message: 'A'
  })
}